"use client";

import { useEffectOnce } from "react-use";
import { initDatadog } from "../../services/observability";

export default function DatadogInit() {
  useEffectOnce(() => {
    initDatadog();
  });

  return null;
}
